import React from "react";
import PersonIcon from '@material-ui/icons/Person';
// import EventIcon from '@material-ui/icons/Event';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import ReceiptIcon from '@material-ui/icons/Receipt';
// import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
// import HistoryIcon from '@material-ui/icons/History';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import ItemMenuTooltip from "./ItemMenuTooltip";
import { RenderTransition } from "../../../common/RenderTransition";
import MenuClose from "./MenuClose";
import { useSelector } from "react-redux";

const ListItemClose = () => {
    const { rol } = useSelector(state => state.auth)

    const settlement = [
        //         {
        //     name: "Solicitud medicamentos",
        //     to: "request-pharmacy"
        // },
        {
            name: "Nuevo lote",
            to: "new-settlements"
        },
        {
            name: "Lotes",
            to: "settlements"
        },
    ]

    let conventions = [
        {
            name: "Consultar convenios",
            to: "conventions"
        },

    ]
    if (rol !== 'subprestador') {
        conventions = [
            {
                name: "Consultar convenios",
                to: "conventions"
            },
            // {
            //     name: "Solicitar modificaciones",
            //     to: "historical-debt"
            // },
        ]
    }

    return (<RenderTransition>
            <ItemMenuTooltip to={"/provider"} title={"Prestador"} icon={<PersonIcon />} />
            <ItemMenuTooltip to={"/orders"} title={"Órdenes"} icon={<ReceiptIcon />} />
            {rol !== 'subprestador' && <MenuClose submenus={settlement} title={"Liquidación"} icon={<LocalHospitalIcon />} />}
            {rol !== 'subprestador' && <ItemMenuTooltip to={"/sub-provider"} title={"Prestador"} icon={<PermContactCalendarIcon />} />}
            <MenuClose submenus={conventions} title={"Convenios"} icon={<AccountBalanceWalletIcon />} />
            <ItemMenuTooltip to={"/contact"} title={"Contacto"} icon={<ContactSupportIcon />} />
    </RenderTransition>)
}

export default ListItemClose;

